export const deleteLocalStorage = () => {
    localStorage.clear();
}
